<script>
import logo from "@/mixins/logo";
import authService from "@/services/auth";
import { version } from "../../../package.json";

export default {
  name: "Login",

  mixins: [logo],

  data() {
    return {
      isLoading: false,
      version,
      username: "",
      password: "",
    };
  },

  methods: {
    signIn() {
      this.isLoading = true;
      authService
        .authenticate(this.username, this.password)
        .then(() => {
          const path =
            this.$route.query && this.$route.query.redirectUrl
              ? this.$route.query.redirectUrl
              : { name: "home" };
          this.$router.push(path);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<template lang="pug">
  .login
    .login__container
      form.login__card(@submit.prevent="signIn")
        .login__img
          img.login__logo(v-if="logoUrl" :src="logoUrl" :alt="`Logo ${theme}`")
          micon.login__svg(v-else :name="'quantux-logo-horizontal-nuevo'")
        el-input#username(placeholder="Usuario" autofocus="true" v-model="username" autocapitalize="none")
        el-input#password(type="password" placeholder="Contraseña" v-model="password" show-password)
        el-button(type="primary" native-type="submit" :disabled="!username || !password" :loading="isLoading") Iniciar Sesión
        router-link.login__link(:to="{ name: 'password-forgot' }") ¿Olvidaste tu contraseña?

        small.version v.{{ version }}
</template>

<style lang="scss">
.login {
  .version {
    position: absolute;
    bottom: 10px;
    right: 10px;
  }

  .login__img {
    margin-bottom: 30px;
  }

  .login__svg {
    width: 300px !important;
    height: 45px !important;
  }

  .el-input {
    margin-bottom: 10px;
  }

  button {
    width: 100%;
  }
}
</style>
